module.exports = __webpack_public_path__ + "static/media/f.99d3e67f.png";